// Shared config for the Client Feedback (Client Satisfaction Report) form + print.

export const LIKERT_LEGEND = [
  { n: 1, label: "Very Poor", desc: "Something you did not understand at all, or were completely dissatisfied with" },
  { n: 2, label: "Poor", desc: "The service or process was weak and needed significant improvement" },
  { n: 3, label: "Average", desc: "The service was acceptable, neither very good nor very bad" },
  { n: 4, label: "Good", desc: "You were generally satisfied and found the service good" },
  { n: 5, label: "Very Good", desc: "The service was outstanding and you were fully satisfied" },
];

export const CLIENT_SECTIONS = [
  {
    title: "Section A: Admission Process",
    questions: [
      { key: "a1_admission_organized", label: "On a scale of 1 to 5, how organized was the admission process?" },
      { key: "a2_involved_irp", label: "How involved were you in developing your Individual Rehab Plan (IRP)?" },
      { key: "a3_prp_reviewing", label: "Was your PRP reviewing the IRP with you regularly?" },
      { key: "a4_opportunity_questions", label: "Were you given the opportunity to ask questions and share input?" },
      { key: "a5_questions_answered", label: "Were All your questions Answered?" },
      { key: "a6_care_focus_recovery", label: "How much did your care focus on recovery?" },
      { key: "a7_physical_health", label: "Did you receive appropriate treatment for physical health needs?" },
      { key: "a8_psychiatrist_visits", label: "Were you satisfied with the visits of your consultant psychiatrist?" },
    ],
  },
  {
    title: "Section B: Progress & Rehabilitation Outcomes",
    questions: [
      { key: "b1_satisfaction_progress", label: "Satisfaction with progress toward recovery goals" },
      { key: "b2_manage_daily", label: "Ability to manage daily activities" },
      { key: "b3_quality_life", label: "Improvement in quality of life" },
      { key: "b4_confidence_maintaining", label: "Confidence in maintaining progress after discharge" },
      { key: "b5_rehab_effectiveness", label: "Rehabilitation effectiveness in improving daily functioning" },
      { key: "b6_needs_addressed", label: "Were all your rehabilitation needs addressed?" },
      { key: "b7_reintegrate", label: "Preparedness to reintegrate into community" },
    ],
  },
  {
    title: "Section C: Community Integration",
    questions: [
      { key: "c1_social_connections", label: "Help in building social connections" },
      { key: "c2_community_resources", label: "Were you satisfied with your Awareness of community / family resources" },
    ],
  },
  {
    title: "Section D: Communication & Support",
    questions: [
      { key: "d1_clarity_info", label: "Clarity of information provided by the team" },
      { key: "d2_concerns_serious", label: "Did the team take your concerns seriously?" },
      { key: "d3_voice_opinions", label: "Were you satisfied with staff to encourage you to voice your opinions?" },
    ],
  },
  {
    title: "Section E: Dignity, Respect & Rights",
    questions: [
      { key: "e1_trust_team", label: "Trust in healthcare team" },
      { key: "e2_dignity_respect", label: "Treated with dignity and respect" },
      { key: "e3_confidentiality", label: "Are you satisfied Confidentiality maintained" },
      { key: "e4_complaint_aware", label: "Were you aware of complaint mechanism?" },
      { key: "e5_complaint_timely", label: "Was your complaint addressed timely?" },
    ],
  },
  {
    title: "Section F: Medication Management",
    questions: [
      { key: "f1_reasons_explained", label: "Were medication reasons explained?" },
      { key: "f2_side_effects", label: "Were side effects explained?" },
      { key: "f3_understanding_purpose", label: "Understanding of medication purpose" },
      { key: "f4_guidance_after", label: "Guidance on medication after discharge" },
      { key: "f5_confidence_managing", label: "Confidence in managing medication" },
      { key: "f6_issues_addressed", label: "Were medication issues addressed properly" },
    ],
  },
  {
    title: "Section G: Family Involvement",
    questions: [
      { key: "g1_family_educated", label: "Family educated about condition" },
      { key: "g2_family_attended", label: "Family attended sessions" },
      { key: "g3_family_preparedness", label: "Family preparedness to support" },
      { key: "g4_comfort_involvement", label: "Comfort with family involvement" },
      { key: "g5_helpfulness", label: "Helpfulness of family involvement" },
      { key: "g6_concerns_support", label: "Concerns about family support" },
      { key: "g7_confidence_boundaries", label: "Confidence in family respecting boundaries" },
    ],
  },
  {
    title: "Section H: Environment & Facilities",
    questions: [
      { key: "h1_cleanliness", label: "Cleanliness and hygiene" },
      { key: "h2_comfort_accommodation", label: "Comfort of accommodation" },
      { key: "h3_safety_security", label: "Safety and security" },
      { key: "h4_food_quality", label: "Food quality" },
    ],
  },
  {
    title: "Section I: Day Rehabilitation Program",
    questions: [
      { key: "i1_group_sessions", label: "Effectiveness of group sessions" },
      { key: "i2_coping_skills", label: "Help in developing coping skills" },
      { key: "i3_reduction_stigma", label: "Reduction in stigma" },
      { key: "i4_discharge_plan", label: "Did you have a discharge plan?" },
      { key: "i5_length_stay", label: "Was length of stay appropriate?" },
    ],
  },
  {
    title: "Section J: Discharge Planning",
    questions: [
      { key: "j1_preparedness", label: "Preparedness for discharge" },
      { key: "j2_followup_info", label: "Information on follow-up care" },
      { key: "j3_emergency_protocol", label: "Emergency protocol provided" },
      { key: "j4_next_steps", label: "Guidance on next steps after discharge" },
    ],
  },
  {
    title: "Section K: Staff Satisfaction",
    questions: [
      { key: "k1_psychiatrist", label: "Psychiatrist" },
      { key: "k2_general_physician", label: "General Physician" },
      { key: "k3_nurses", label: "Nurses" },
      { key: "k4_prp", label: "PRP" },
    ],
  },
  {
    title: "Section L: Overall Evaluation",
    questions: [
      { key: "l1_overall_satisfaction", label: "Overall satisfaction with TRH" },
      { key: "l2_would_return", label: "Would you return to TRH if needed?" },
      { key: "l3_would_recommend", label: "Would you recommend TRH to others?" },
    ],
  },
];

// Flat list of all likert keys (for defaults / iteration).
export const CLIENT_LIKERT_KEYS = CLIENT_SECTIONS.flatMap((s) => s.questions.map((q) => q.key));
